export const ATTRIBUTE_KEYS = ['str', 'agi', 'vit', 'ene'] as const;
export type AttributeKey = (typeof ATTRIBUTE_KEYS)[number];
export type Attributes = Record<AttributeKey, number>;

export const ATTRIBUTE_INFO: Readonly<Record<AttributeKey, { name: string; description: string }>> = {
  str: { name: 'Strength', description: 'Raises physical attack.' },
  agi: { name: 'Agility', description: 'Raises critical chance, accuracy and evasion.' },
  vit: { name: 'Vitality', description: 'Raises maximum health and defence.' },
  ene: { name: 'Inner Energy', description: 'Raises maximum qi, qi attack and qi regeneration.' },
};

/** Item / derived stat keys that equipment can roll. */
export const STAT_KEYS = ['atk', 'qiAtk', 'def', 'hp', 'mp', 'crit', 'evasion', 'accuracy'] as const;
export type StatKey = (typeof STAT_KEYS)[number];
export type StatBlock = Partial<Record<StatKey, number>>;

export const STAT_INFO: Readonly<Record<StatKey, { name: string; percent: boolean }>> = {
  atk: { name: 'Attack', percent: false },
  qiAtk: { name: 'Qi Attack', percent: false },
  def: { name: 'Defence', percent: false },
  hp: { name: 'Health', percent: false },
  mp: { name: 'Qi', percent: false },
  crit: { name: 'Critical Chance', percent: true },
  evasion: { name: 'Evasion', percent: true },
  accuracy: { name: 'Accuracy', percent: true },
};
